export default function renderOverviewText(point) {
  switch (true) {
    case point <= 10 && point >= 9:
      return 'Xuất sắc';

    case point < 9 && point >= 7:
      return 'Tốt';

    case point < 7 && point >= 5:
      return 'Ổn';

    case point < 5 && point >= 3:
      return 'Tệ';

    default:
      return 'Rất tệ';
  }
}
